export class News {
  public id: string = "";
  public title: string = "";
  public link: string = "";
  public category: string = "";
  public description: string = "";
  public imagePath: string = "";
  public chapterName: string = "";
  public creationTime: Date = new Date();
}
